import { render, staticRenderFns } from "./cta_block.vue?vue&type=template&id=225f7d08&scoped=true&"
import script from "./cta_block.vue?vue&type=script&lang=js&"
export * from "./cta_block.vue?vue&type=script&lang=js&"
import style0 from "./cta_block.vue?vue&type=style&index=0&id=225f7d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f7d08",
  null
  
)

export default component.exports